import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ContactForm } from "./ContactForm";

interface ContactDialogProps {
  triggerComponent: React.ReactNode;
  className?: string;
}

export default function ContactDialog({
  triggerComponent,
  className,
}: ContactDialogProps) {
  return (
    <Dialog>
      <DialogTrigger className={className}>{triggerComponent}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle></DialogTitle>
          <DialogDescription></DialogDescription>
          <ContactForm />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
